import Vue from "vue";
import Router from "vue-router";
import VueCookie from "vue-cookie";

import Dashboard from "../pages/Dashboard.vue";
import Products from "../pages/Product/index.vue";
import ProductCreate from "../pages/Product/create.vue";
import ProductEdit from "@/pages/Product/edit.vue";
import ProductBrands from "../pages/ProductBrand/index.vue";
import ProductBrandsCreate from "@/pages/ProductBrand/create.vue";
import ProductBrandsEdit from "@/pages/ProductBrand/edit.vue";
import Suppliers from "@/pages/Supplier/index.vue";
import SupplierCreate from "@/pages/Supplier/create.vue";
import SupplierEdit from "@/pages/Supplier/edit.vue";
import Users from "@/pages/User/index.vue";
import UserCreate from "@/pages/User/create.vue";
import UserEdit from "@/pages/User/edit.vue";
import Category from "@/pages/Category/index.vue";
import CategoryCreate from "@/pages/Category/create.vue";
import CategoryEdit from "@/pages/Category/edit.vue";
import SubCategories from "@/pages/Subcategory/index.vue";
import SubcategoryCreate from "@/pages/Subcategory/create.vue";
import SubcategoryEdit from "@/pages/Subcategory/edit.vue";
import Surgeries from "@/pages/Surgeries/index.vue";
import SurgeryEdit from "@/pages/Surgeries/edit.vue";
import SurgeryCreate from "@/pages/Surgeries/create.vue";
import Orders from "@/pages/Order/index.vue";
import OrderDetail from "@/pages/Order/detail.vue";
import ShipmentProfiles from "@/pages/Shipment/Profile/index.vue";
import ShipmentProfileCreate from "@/pages/Shipment/Profile/create.vue";
import ShipmentProfileEdit from "@/pages/Shipment/Profile/edit.vue";
import SalesInvoice from "@/pages/Finance/SalesInvoice/index.vue";
import SalesInvoiceDetail from "@/pages/Finance/SalesInvoice/detail.vue";
import CommissionInvoice from "@/pages/Finance/CommissionInvoice/index.vue";
import CommissionInvoiceDetail from "@/pages/Finance/CommissionInvoice/detail.vue";
import PurchaseInvoice from "@/pages/Finance/PurchaseInvoice/index.vue";
import PurchaseInvoiceDetail from "@/pages/Finance/PurchaseInvoice/detail.vue";
import SupplierOrders from "@/pages/Supplier/Order/index.vue";
import Admins from "@/pages/AdminUser/index.vue";
import AdminEdit from "@/pages/AdminUser/edit.vue";
import AdminCreate from "@/pages/AdminUser/create.vue";
import SupplierReview from "@/pages/Supplier/Review/index.vue";
import SupplierOrderDetail from "@/pages/Supplier/Order/detail.vue";

import Social from "../pages/Social.vue";
import Media from "../pages/Media.vue";
import Snackbar from "../pages/Snackbar.vue";
import Chart from "../pages/Chart.vue";
import Mailbox from "../pages/Mailbox.vue";
import Calendar from "../pages/Calendar.vue";
import Login from "../pages/core/Login.vue";
import Error from "../pages/core/Error.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "/dashboard",
      meta: {
        auth: true
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        breadcrumb: [{ name: "Overview" }],
        auth: true
      }
    },
    {
      path: "/orders",
      name: "Orders",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/orders",
          name: "order-index",
          component: Orders,
          meta: {
            breadcrumb: [{ name: "Orders" }],
            module: "order",
            auth: true
          }
        },
        {
          path: "/orders/:id",
          name: "order-detail",
          component: OrderDetail,
          meta: {
            breadcrumb: [{ name: "Order Detail" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/supplier-orders",
      name: "supplierorders",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/supplier-orders",
          name: "supplierorder-index",
          component: SupplierOrders,
          meta: {
            breadcrumb: [{ name: "Supplier Orders" }],
            auth: true,
            module: "supplierorder"
          }
        },
        {
          path: "/supplier-orders/:supplierId/:id",
          name: "supplierorder-detail",
          component: SupplierOrderDetail,
          meta: {
            breadcrumb: [{ name: "Supplier Order Details" }],
            auth: true,
            module: "supplierorder"
          },
          props: true
        }
      ]
    },
    {
      path: "/products",
      name: "Products",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/products",
          name: "product-index",
          component: Products,
          meta: {
            breadcrumb: [{ name: "Products" }],
            create: "product-create",
            auth: true,
            module: "product"
          }
        },
        {
          path: "/products/create",
          name: "product-create",
          component: ProductCreate,
          meta: {
            breadcrumb: [{ name: "Create Product" }],
            auth: true
          }
        },
        {
          path: "/products/edit/:id",
          name: "product-edit",
          component: ProductEdit,
          meta: {
            breadcrumb: [{ name: "Edit Product" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/products-create",
      name: "ProductsCreate",
      component: ProductCreate,
      meta: {
        breadcrumb: [{ name: "Create Product" }],
        auth: true
      }
    },
    {
      path: "/brands",
      name: "Brands",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/brands",
          name: "brand-index",
          component: ProductBrands,
          meta: {
            breadcrumb: [{ name: "Product Brands" }],
            create: "brand-create",
            auth: true,
            module: "brand"
          }
        },
        {
          path: "/brands/create",
          name: "brand-create",
          component: ProductBrandsCreate,
          meta: {
            breadcrumb: [{ name: "Create Product Brand" }],
            auth: true
          }
        },
        {
          path: "/brands/edit/:id",
          name: "brand-edit",
          component: ProductBrandsEdit,
          meta: {
            breadcrumb: [{ name: "Edit Product Brand" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/suppliers",
      name: "Suppliers",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/suppliers",
          name: "supplier-index",
          component: Suppliers,
          meta: {
            breadcrumb: [{ name: "Suppliers" }],
            create: "supplier-create",
            auth: true,
            module: "supplier"
          }
        },
        {
          path: "/suppliers/create",
          name: "supplier-create",
          component: SupplierCreate,
          meta: {
            breadcrumb: [{ name: "Supplier Create" }],
            auth: true
          }
        },
        {
          path: "/suppliers/edit/:id",
          name: "supplier-edit",
          component: SupplierEdit,
          meta: {
            breadcrumb: [{ name: "Supplier Edit" }],
            module: "order",
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/admins",
      name: "Admins",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/admins",
          name: "admin-index",
          component: Admins,
          meta: {
            breadcrumb: [{ name: "Admins" }],
            create: "admin-create",
            auth: true,
            module: "admin"
          }
        },
        {
          path: "/admins/create",
          name: "admin-create",
          component: AdminCreate,
          meta: {
            breadcrumb: [{ name: "Admin Create" }],
            auth: true
          },
          props: true
        },
        {
          path: "/admins/:id",
          name: "admin-edit",
          component: AdminEdit,
          meta: {
            breadcrumb: [{ name: "Admin Edit" }],
            module: "admin",
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/users",
      name: "Users",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/users",
          name: "user-index",
          component: Users,
          meta: {
            breadcrumb: [{ name: "Users" }],
            auth: true,
            create: "user-create",
            module: "user"
          }
        },
        {
          path: "/users/create",
          name: "user-create",
          component: UserCreate,
          meta: {
            breadcrumb: [{ name: "Create Users" }],
            auth: true
          }
        },
        {
          path: "/users/edit/:id",
          name: "user-edit",
          component: UserEdit,
          meta: {
            breadcrumb: [{ name: "Edit User" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/categories",
      name: "Categories",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/categories",
          name: "category-index",
          component: Category,
          meta: {
            breadcrumb: [{ name: "Categories" }],
            create: "category-create",
            auth: true,
            module: "category"
          }
        },
        {
          path: "/categories/create",
          name: "category-create",
          component: CategoryCreate,
          meta: {
            breadcrumb: [{ name: "Create Category" }],
            auth: true
          }
        },
        {
          path: "/categories/edit/:id",
          name: "category-edit",
          component: CategoryEdit,
          meta: {
            breadcrumb: [{ name: "Edit Category" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/subcategories",
      name: "Subcategories",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/subcategories",
          name: "subcategory-index",
          component: SubCategories,
          meta: {
            breadcrumb: [{ name: "Product Subcategories" }],
            create: "subcategory-create",
            auth: true,
            module: "subcategory"
          }
        },
        {
          path: "/subcategories/create",
          name: "subcategory-create",
          component: SubcategoryCreate,
          meta: {
            breadcrumb: [{ name: "Create Subcategory" }],
            auth: true
          }
        },
        {
          path: "/subcategory/edit/:id",
          name: "subcategory-edit",
          component: SubcategoryEdit,
          meta: {
            breadcrumb: [{ name: "Edit Subcategory" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/surgeries",
      name: "Surgeries",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/surgeries",
          name: "surgery-index",
          component: Surgeries,
          meta: {
            breadcrumb: [{ name: "Surgeries" }],
            create: "surgery-create",
            auth: true,
            module: "surgery"
          }
        },
        {
          path: "/surgeries/create",
          name: "surgery-create",
          component: SurgeryCreate,
          meta: {
            breadcrumb: [{ name: "Create Surgery" }],
            auth: true
          }
        },
        {
          path: "/surgeries/edit/:id",
          name: "surgery-edit",
          component: SurgeryEdit,
          meta: {
            breadcrumb: [{ name: "Edit Surgery" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/shipment-profiles",
      name: "shipmentprofile",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/shipment-profiles",
          name: "shipmentprofile-index",
          component: ShipmentProfiles,
          meta: {
            breadcrumb: [{ name: "Shipment Profiles" }],
            create: "shipmentprofile-create",
            auth: true,
            module: "shipmentprofile"
          }
        },
        {
          path: "/shipment-profiles/create",
          name: "shipmentprofile-create",
          component: ShipmentProfileCreate,
          meta: {
            breadcrumb: [{ name: "Create Shipment Profile" }],
            auth: true
          }
        },
        {
          path: "/shipment-profiles/edit/:id",
          name: "shipmentprofile-edit",
          component: ShipmentProfileEdit,
          meta: {
            breadcrumb: [{ name: "Edit Shipment Profile" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/sales-invoice",
      name: "salesinvoice",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/sales-invoice",
          name: "salesinvoice-index",
          component: SalesInvoice,
          meta: {
            breadcrumb: [{ name: "Sales Invoice" }],
            auth: true,
            modules: "salesinvoice"
          }
        },
        {
          path: "/sales-invoice/:id",
          name: "salesinvoice-detail",
          component: SalesInvoiceDetail,
          meta: {
            breadcrumb: [{ name: "Sales Invoice Details" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/commission-invoice",
      name: "commissioninvoice",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/commission-invoice",
          name: "commissioninvoice-index",
          component: CommissionInvoice,
          meta: {
            breadcrumb: [{ name: "Commission Invoice" }],
            auth: true,
            module: "commissioninvoice"
          }
        },
        {
          path: "/commission-invoice/:id",
          name: "commissioninvoice-detail",
          component: CommissionInvoiceDetail,
          meta: {
            breadcrumb: [{ name: "Commission Invoice Details" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/purchase-invoice",
      name: "purchaseinvoice",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/purchase-invoice",
          name: "purchaseinvoice-index",
          component: PurchaseInvoice,
          meta: {
            breadcrumb: [{ name: "Purchase Invoice" }],
            auth: true,
            module: "purchaseinvoice"
          }
        },
        {
          path: "/purchase-invoice/:id",
          name: "purchaseinvoice-detail",
          component: PurchaseInvoiceDetail,
          meta: {
            breadcrumb: [{ name: "Purchase Invoice Details" }],
            auth: true
          },
          props: true
        }
      ]
    },
    {
      path: "/supplier-reviews",
      name: "supplierreview",
      component: () => import("@/pages/View.vue"),
      children: [
        {
          path: "/supplier-reviews",
          name: "supplierreview-index",
          component: SupplierReview,
          meta: {
            breadcrumb: [{ name: "Supplier Reviews " }],
            auth: true,
            module: "suppliereview"
          }
        }
      ]
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/pages/User/profile.vue")
    },
    {
      path: "/mailbox",
      name: "Mailbox",
      component: Mailbox,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "mailbox" }
        ]
      }
    },
    {
      path: "/snackbar",
      name: "Snackbar",
      component: Snackbar,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "snackbar" }
        ]
      }
    },
    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "calendar" }
        ]
      }
    },
    {
      path: "/social",
      name: "Social",
      component: Social,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "social" }
        ]
      }
    },
    {
      path: "/media",
      name: "Media",
      component: Media,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "media" }
        ]
      }
    },
    {
      path: "/chart",
      name: "Chart",
      component: Chart,
      meta: {
        breadcrumb: [
          { name: "dashboard", href: "Dashboard" },
          { name: "charts" }
        ]
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
      meta: {
        allowAnonymous: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    let isLoggedIn = VueCookie.get("token");
    if (isLoggedIn) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
